import React, { useState, useEffect, useRef } from 'react';
import { Col, Button, MenuItem, DropdownButton, ButtonGroup, Modal, FormGroup, ControlLabel, Radio, FormControl, Glyphicon } from 'react-bootstrap';
import Request from 'superagent';

export default function SelectScreen({
    userProfile, eventID, refreshScreenList, selectedScreen, allowForNewScreen,
    newEventScreenModuleSelected, screenCountForEvent, itemDeleted, screenNameShowDelete,
}) {
    const [screensData, setScreensData] = useState([]);
    const [screenName, setScreenName] = useState('');
    const [modalScreenName, setModalScreenName] = useState('');
    const [screenButtonDisabled, setScreenButtonDisabled] = useState(true);
    const [showCreateScreen, setShowCreateScreen] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [deviceType, setDeviceType] = useState('desktop');
    const [screenDeleted, setScreenDeleted] = useState(false);
    const [timeMaster, setTimeMaster] = useState(false);
    const [modalTimeMaster, setModalTimeMaster] = useState(false);
    const [timeMasterText, setTimeMasterText] = useState('');
    const [currentTimeMaster, setCurrentTimeMaster] = useState('');
    const [mode, setMode] = useState('');
    const [waitingNetwork, setWaitingNetwork] = useState(false);
    const [eventScreenID, setEventScreenID] = useState(null);

    const selectScreenRef = useRef(null);
    const remoteIPRef = useRef('');

    // componentDidMount + CWRP eventID
    const firstEventIDRender = useRef(true);
    useEffect(() => {
        if (firstEventIDRender.current) {
            firstEventIDRender.current = false;
            if (eventID !== 0) getAllScreens(eventID);
            return;
        }
        if (eventID !== 0) {
            getAllScreens(eventID);
            setScreenName('');
            setScreenButtonDisabled(false);
        }
    }, [eventID]);

    // CWRP refreshScreenList
    const firstRefreshRender = useRef(true);
    useEffect(() => {
        if (firstRefreshRender.current) { firstRefreshRender.current = false; return; }
        getAllScreens(eventID);
    }, [refreshScreenList]);

    // CWRP selectedScreen.screenName
    const firstSelectedRender = useRef(true);
    useEffect(() => {
        if (firstSelectedRender.current) { firstSelectedRender.current = false; return; }
        if (selectedScreen?.screenName !== undefined) {
            setScreenName(selectedScreen.screenName);
        }
    }, [selectedScreen?.screenName]);

    function getAllScreens(eid) {
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=queryGetEventScreens&argument2=' + JSON.stringify({ eventID: eid });
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                screenCountForEvent(response.body[0].rowCount);
                remoteIPRef.current = response.body[0].remoteIP;
                const data = response.body[0].data;
                const currentTM = data.find(d => d.time_master === 't')?.screen_name ?? '';
                setCurrentTimeMaster(currentTM);
                setScreensData(data);
            }
        });
    }

    function screenSelected(eid) {
        if (eid === 'New') {
            setModalScreenName('');
            setMode('create');
            setModalTimeMaster(false);
            setTimeMasterText('Make this dashboard the Time Master. ' + (currentTimeMaster.length > 0 ? currentTimeMaster + ' is currently the Time Master.' : ''));
            setShowCreateScreen(true);
        } else {
            setMode('edit');
            const screenRow = screensData.find(s => s.event_screen_id === eid);
            if (screenRow) {
                const sel = {
                    deviceType: screenRow.device_type,
                    clientPublicIP: remoteIPRef.current,
                    timeMaster: screenRow.time_master === 't',
                    eventScreenID: eid,
                    screenName: screenRow.screen_name,
                };
                setScreenName(screenRow.screen_name);
                newEventScreenModuleSelected(sel);
                setTimeMaster(screenRow.time_master === 't');
                setEventScreenID(eid);
            }
        }
    }

    function showEditScreen() {
        const tmText = 'Make this dashboard the Time Master. ' + ((!timeMaster && currentTimeMaster.length > 0) ? currentTimeMaster + ' is currently the Time Master.' : '');
        setTimeMasterText(tmText);
        setModalScreenName(screenName);
        setModalTimeMaster(timeMaster);
        setShowCreateScreen(true);
    }

    function saveScreen() {
        setWaitingNetwork(true);
        const params = {
            screenName: modalScreenName,
            eventID,
            device_type: deviceType,
            timeMaster: modalTimeMaster ? 't' : 'f',
            mode,
            event_screen_id: eventScreenID,
        };
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=saveScreen&argument2=' + JSON.stringify([params]);
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                setShowCreateScreen(false);
                setWaitingNetwork(false);
                const newEventScreenID = response.body[0].data[0].event_screen_id;
                const sel = {
                    deviceType,
                    clientPublicIP: response.body[0].remoteIP,
                    eventScreenID: newEventScreenID,
                    timeMaster: response.body[0].data[0].time_master === 't',
                    screenName: modalScreenName,
                };
                newEventScreenModuleSelected(sel);
                setEventScreenID(newEventScreenID);
                setScreenName(modalScreenName);
                setTimeMaster(modalTimeMaster);
                getAllScreens(eventID);
            }
        });
    }

    function deleteScreen() {
        setShowCreateScreen(false);
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=deleteScreen&argument2=' + JSON.stringify([{ eventScreenID }]);
        Request.get(url).then((response) => {
            if (response.body[0].Result === 'OK') {
                getAllScreens(eventID);
                itemDeleted?.();
                setScreenName(prev => prev + ' Deleted');
                setScreenDeleted(true);
                setTimeout(() => {
                    setScreenDeleted(false);
                    setScreenName('');
                }, 1200);
            }
        });
    }

    function handleChange(e) {
        if (e.target.name === 'timeMaster') {
            setModalTimeMaster(prev => !prev);
        } else {
            setModalScreenName(e.target.value);
            setValidationError(null);
        }
    }

    const colStyle = { paddingRight: 0 };
    let xsButton = 3, smButton = 2, mdButton = 2, lgButton = 1;
    let xsDisplay = 6, smDisplay = 4, mdDisplay = 4, lgDisplay = 4;
    let colRightStyle = {};
    if (allowForNewScreen) {
        xsButton = 3; smButton = 3; mdButton = 2; lgButton = 2;
        xsDisplay = 9; smDisplay = 8; mdDisplay = 6; lgDisplay = 4;
        colRightStyle = { paddingRight: 0 };
        colStyle.paddingLeft = 0;
    }

    const errorMsgStyle = { display: validationError === 'error' ? 'block' : 'none', color: 'red', position: 'absolute', left: '15px' };
    const tablet = { width: '62px', height: '50px', borderColor: deviceType === 'tablet' ? 'black' : 'lightgrey', borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px' };
    const desktop = { width: '88px', height: '50px', borderColor: deviceType === 'desktop' ? 'black' : 'lightgrey', borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px' };
    const mobilePortrait = { width: '50px', height: '88px', borderColor: deviceType === 'mobilePortrait' ? 'black' : 'lightgrey', borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px' };
    const mobileLandscape = { height: '50px', width: '88px', borderColor: deviceType === 'mobileLandscape' ? 'black' : 'lightgrey', borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px' };
    const landscapeButtonStyle = { verticalAlign: 'top', height: '110px' };
    const deleteButtonStyle = { right: '20px', top: '10px', position: 'absolute', display: mode === 'edit' ? 'block' : 'none' };
    const modalTitle = mode === 'create' ? 'Create Dashboard' : 'Edit Dashboard';

    let editScreen = null;
    if (mode === 'edit' && allowForNewScreen && screenName.length > 0 && selectScreenRef.current) {
        const lineHeight = selectScreenRef.current.parentElement.offsetHeight + 'px';
        editScreen = (
            <Glyphicon key="edit"
                onClick={showEditScreen}
                className="cog"
                style={{ lineHeight, textAlign: 'center', height: lineHeight }}
                bsSize="large"
                glyph="wrench" />
        );
    }

    const menuItems = [
        ...screensData.map(d => (
            <MenuItem key={d.event_screen_id} eventKey={d.event_screen_id}>{d.screen_name}</MenuItem>
        )),
    ];
    if (allowForNewScreen) {
        if (screensData.length > 0) menuItems.push(<MenuItem key="divider" divider eventKey="divider" />);
        menuItems.push(<MenuItem key="new" eventKey="New">New Dashboard</MenuItem>);
    }

    return (
        <div ref={selectScreenRef}>
            <Modal show={showCreateScreen} onHide={() => setShowCreateScreen(false)}>
                <Modal.Header>
                    <Modal.Title>
                        {modalTitle}
                        <Button bsStyle="warning"
                            disabled={!screenNameShowDelete}
                            style={deleteButtonStyle}
                            onClick={deleteScreen}>
                            Delete Dashboard
                        </Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup controlId="formValidationError1" validationState={validationError}>
                        <ControlLabel>Dashboard Name</ControlLabel>
                        <FormControl type="text"
                            autoFocus={true}
                            className="form-control input-md"
                            name="newScreenName"
                            value={modalScreenName}
                            onChange={handleChange}
                            placeholder="Name"
                            style={{ width: '100%' }} />
                    </FormGroup>
                    <br />
                    <ControlLabel>Select the smallest device that you plan to use for this dashboard</ControlLabel>
                    <br />
                    <Radio name="deviceType" inline value="mobilePortrait" checked={deviceType === 'mobilePortrait'} onChange={e => setDeviceType(e.target.value)}>
                        Mobile <br /><div style={mobilePortrait} />
                    </Radio>{' '}
                    <Radio name="deviceType" style={landscapeButtonStyle} value="mobileLandscape" inline checked={deviceType === 'mobileLandscape'} onChange={e => setDeviceType(e.target.value)}>
                        Mobile <br /><div style={mobileLandscape} />
                    </Radio>
                    <br /><br />
                    <Radio name="deviceType" inline value="tablet" checked={deviceType === 'tablet'} onChange={e => setDeviceType(e.target.value)}>
                        Tablet <br /><div style={tablet} />
                    </Radio>{' '}
                    <Radio name="deviceType" inline value="desktop" checked={deviceType === 'desktop'} onChange={e => setDeviceType(e.target.value)}>
                        Desktop/Laptop/Large Tablet <br /><div style={desktop} />
                    </Radio>
                    <br /><br />
                    <input name="timeMaster" checked={modalTimeMaster} onChange={handleChange} type="checkbox" value="" />
                    {' '}{timeMasterText}
                    <br />
                    <span style={errorMsgStyle}><br />Dashboard already exists</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" disabled={modalScreenName.length === 0 || waitingNetwork} onClick={saveScreen}>Save</Button>
                    <Button bsStyle="danger" onClick={() => setShowCreateScreen(false)}>Cancel</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={screenDeleted} onHide={() => setScreenDeleted(false)}>
                <Modal.Body>
                    <span style={{ color: 'red' }}>{screenName}</span>
                </Modal.Body>
            </Modal>

            <Col xs={xsButton} sm={smButton} md={mdButton} lg={lgButton} style={colStyle}>
                <ButtonGroup justified>
                    <DropdownButton
                        bsStyle="primary"
                        title="Dashboard"
                        key={2}
                        id="dropdown-dashboard"
                        style={{ paddingLeft: '4px', paddingRight: '4px' }}
                        onSelect={screenSelected}
                        disabled={screenButtonDisabled}>
                        {menuItems}
                    </DropdownButton>
                </ButtonGroup>
            </Col>

            <Col xs={xsDisplay} sm={smDisplay} md={mdDisplay} lg={lgDisplay} style={colRightStyle}>
                <input type="text"
                    className="form-control input-md"
                    name="screenName"
                    value={screenName}
                    onChange={() => {}}
                    placeholder="Dashboard"
                    style={{ width: '100%' }}
                    disabled={true} />
            </Col>
            <Col xs={1} sm={1} md={1} lg={1}>{editScreen}</Col>
        </div>
    );
}
